import getApiUrl from '../functions/getApiUrl';

export const uploadProxy =
    `${getApiUrl()}upload/?url=`
    
const proxy = `${getApiUrl()}?url=`

export default proxy;

